import React from 'react';
import {Typography} from '@mui/material';
import {Box} from '@mui/system';
import CheckIcon from '@mui/icons-material/Check';
import {PlanRow} from '../CreateBuilder/BuilderSourceDestination/PlanRow';
import {PlanAccordionShell} from '../CreateBuilder/BuilderSourceDestination/PlanAccordionShell';
import {planFormClasses} from '../CreateBuilder/BuilderSourceDestination/planFormClasses';
import OWNERSHIP from '../../../constants/Ownership';
import {builderFieldsType} from '../CreateBuilder/builderFields';
import {useAutoForm} from '../../../components/AutoForm/useAutoForm';
import {BuilderProps} from '../CreateBuilder/BuilderSourceDestination/builderValidators';

interface ProtectionRowProps extends Pick<BuilderProps, 'contactName'> {
  children?: React.ReactNode;
}

export const ProtectionRow: React.FC<ProtectionRowProps> = ({contactName, children}) => {
  const {values} = useAutoForm<builderFieldsType>();
  const displayName =
    values?.contact === OWNERSHIP.JOINT_CODE ? OWNERSHIP.JOINT_LIVES : contactName;

  return (
    <PlanRow id="notused" reccId="" isSelected isSubplan={false} sameReview={false}>
      <PlanAccordionShell
        expanded
        isSelected
        isSoleParent
        validationLevel="valid"
        summaryChildren={
          <Typography>
            New <strong>personal </strong>protection plan for {displayName}
          </Typography>
        }
        summaryTrailing={
          <Box sx={planFormClasses.validationIcon}>
            <CheckIcon />
          </Box>
        }
      >
        {children}
      </PlanAccordionShell>
    </PlanRow>
  );
};
